import React from 'react'
import { Typography } from 'antd'
import AppConfigurationSettings from '../components/AppConfigurationSettings'

const { Title, Text } = Typography

const TrainingAppConfigurationPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <Title level={2} className="text-3xl font-bold text-gray-900 mb-2">
          Training App Configuration
        </Title>
        <Text type="secondary">
          Manage your LLM Training application sidebar, layout, and UI configurations.
          Drag and drop to reorder items, toggle to enable/disable.
        </Text>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="p-6">
          <AppConfigurationSettings
            applicationFilter="training"
            defaultApplication="training"
          />
        </div>
      </div>
    </div>
  )
}

export default TrainingAppConfigurationPage
